import ScoreSimulator from "./ScoreSimulator";

export default function ScoreSimulatorNew() {
  return <ScoreSimulator />;
}
